import { ShieldCheck, Trash } from "@phosphor-icons/react";

const ROLE_STYLES = {
  manager: "bg-blue-50 text-blue-700 border-blue-200",
  member: "bg-zinc-100 text-zinc-700 border-zinc-200",
};
const roleBadge = (r) =>
  `text-xs px-2 py-0.5 border font-mono uppercase tracking-wider ${ROLE_STYLES[r] || ROLE_STYLES.member}`;

export default function MembersTable({ members, isManager, onToggleRole, onRemove }) {
  return (
    <div className="mt-6 border border-zinc-200 bg-white">
      <div className="px-6 py-4 border-b border-zinc-200 gf-overline">Members</div>
      <table className="w-full text-sm border-collapse">
        <thead>
          <tr className="border-b border-zinc-200 text-left gf-overline">
            <th className="px-6 py-3">Email</th>
            <th className="px-6 py-3">Name</th>
            <th className="px-6 py-3">Role</th>
            <th className="px-6 py-3 text-right">Action</th>
          </tr>
        </thead>
        <tbody>
          {members.map((m) => (
            <tr key={m.id} className="border-b border-zinc-100 hover:bg-zinc-50" data-testid={`member-row-${m.id}`}>
              <td className="px-6 py-4 font-semibold">{m.email}</td>
              <td className="px-6 py-4 text-zinc-600">{m.name}</td>
              <td className="px-6 py-4"><span className={roleBadge(m.company_role)}>{m.company_role}</span></td>
              <td className="px-6 py-4 text-right space-x-3 whitespace-nowrap">
                {isManager && (
                  <button
                    onClick={() => onToggleRole(m)}
                    className="inline-flex items-center gap-1 text-zinc-700 hover:text-zinc-900 hover:underline text-xs uppercase tracking-wide font-bold"
                    data-testid={`toggle-role-${m.id}`}
                  >
                    <ShieldCheck size={14} /> Toggle role
                  </button>
                )}
                {isManager && (
                  <button
                    onClick={() => onRemove(m)}
                    className="inline-flex items-center gap-1 text-red-700 hover:underline text-xs uppercase tracking-wide font-bold"
                    data-testid={`remove-${m.id}`}
                  >
                    <Trash size={14} /> Remove
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export { roleBadge };
